import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import CustomFile from '../../../components/edd/CustomFile/CustomFile';
import { capitalize } from './EddUtils';
import Spinner from '../../../components/Spinner/Spinner';

export const EddFileInfo = memo(props => {
  const {
    fileDetails,
    scheduleClicked,
    importClicked,
    validateClicked,
    deleteClicked,
    filesSelecting,
    setFilesSelecting,
    handleScheduleCanceled,
    deployClicked,
    scheduleDeployClicked,
    downloadClicked,
  } = props;
  const inputRef = useRef(null);

  return (
    <div className=" border-purple-700 border-none border-4 w-[68%] 2xl:w-[60%]">
      <input
        data-test="re-upload-input"
        className="absolute overflow-hidden w-px h-px pointer-events-none"
        type="file"
        ref={inputRef}
        accept=".csv"
        onInput={async e => {
          props.handleInputChange(e);
          inputRef.current.value = '';
        }}
      />
      <div className="mb-8 flex flex-col items-start">
        <div className="w-full mt-8 shadow-2xl z-40 shadow-[20px_20px_60px_#bebebe_-10px_-20px_60px_#ffffff] shadow-[#bebebe]">
          <div className="w-full h-full  bg-white/30 backdrop-blur-[24px] outline-solid outline-white  ">
            <div className="p-4  pl-2 pr-2 grid grid-cols-3">
              <div className="col-span-1 flex mb-2">
                <p className="font-bold text-dark-night">General File Details</p>
              </div>

              <div className="col-span-2 flex items-center mb-2">
                <button
                  type="button"
                  data-test="delete-file"
                  className=" flex mr-4 
                                  2xl:mr-8
                                cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105   
                            bg-red-500
                            active:bg-red-800 
                                hover:!outline 
                                appearance-none 
                                hover:outline-2
                                text-white
                                hover:text-red-500
                                hover:bg-white
                            hover:outline-red-400 
                            h-8 rounded-md justify-start items-center duration-200 p-2 "
                  onClick={deleteClicked}
                >
                  <p className="text-sm text-inherit">Delete File</p>
                </button>

                <button
                  type="button"
                  data-test="import-file-submit"
                  className=" flex mr-4 2xl:mr-8 bg-sunrise text-white
                                cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105 
                                hover:bg-white
                                    hover:text-sunrise
                                    hover:!outline-2
                                    hover:!outline 
                                    hover:outline-sunrise
                                        active:bg-orange-800 
                                        h-8 rounded-md justify-start items-center duration-200 p-2 "
                  onClick={importClicked}
                >
                  <p className="text-sm">Import File</p>
                </button>

                {fileDetails.fileType !== 'tag' && (
                  <button
                    type="button"
                    data-test="deploy-file-submit"
                    className="flex 2xl:mr-8 bg-sunrise text-white
                                cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105 
                                hover:bg-white
                                    hover:text-sunrise
                                    hover:!outline-2
                                    hover:!outline 
                                    hover:outline-sunrise
                                        active:bg-orange-800 
                                        h-8 rounded-md justify-start items-center duration-200 p-2"
                    onClick={deployClicked}
                  >
                    <p className="text-sm">Deploy File</p>
                  </button>
                )}
              </div>

              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">File Name</p>
                <p
                  className="text-dark-night text-sm font-normal leading-normal overflow-hidden truncate"
                  data-test="edd-file-name-value"
                >
                  {fileDetails.fileName}
                </p>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pl-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">File Type</p>

                <div className="flex items-center">
                  <CustomFile fileType={fileDetails.fileType} />
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.fileType}
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Imported By</p>
                <div className="flex items-center">
                  <p
                    className="text-dark-night text-sm font-normal leading-normal"
                    data-test="imported-by-value"
                  >
                    {fileDetails.importStatus === 'imported'
                      ? capitalize(fileDetails.importedBy)
                      : 'Not yet imported'}
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 pl-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Uploaded by</p>
                <p className="text-dark-night text-sm font-normal leading-normal">
                  {capitalize(fileDetails.uploadedBy)}
                </p>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 pl-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Uploaded Date</p>
                <div className="flex items-center">
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.uploadedDateString}
                  </p>
                  <div className={`flex ${fileDetails.fileTheme}`}>
                    {fileDetails.uploadedDayComponent()}
                  </div>
                </div>
              </div>
              {fileDetails.deployStatus ? (
                <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 pl-2">
                  <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                    Deployment Status
                  </p>
                  <div className="flex items-center">
                    <p className="text-dark-night text-sm font-normal leading-normal">
                      {fileDetails.deployStatus}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 pl-2" />
              )}
            </div>
          </div>
        </div>

        <div className="w-full   mt-4 shadow-2xl z-40 shadow-[20px_20px_60px_#bebebe_-10px_-20px_60px_#ffffff] shadow-[#bebebe] ">
          <div className="w-full h-full  bg-white/30 backdrop-blur-[24px] outline-solid outline-white  ">
            <div className="p-4 grid grid-cols-3">
              <div className="col-span-1 flex mb-2">
                <p className="font-bold text-dark-night">Validation Details</p>
              </div>

              <div className="col-span-2 flex items-center mb-2">
                <button
                  type="button"
                  data-test="validate-file-info"
                  className=" flex mr-4 
                                  2xl:mr-8
                            bg-green-600 
                            active:bg-green-800 
                            hover:!outline 
                            hover:!outline-2
                            text-white
                            hover:text-green-500
                            hover:bg-white
                            hover:outline-green-400 
                            text-white cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105    h-8 rounded-md justify-start items-center duration-200 p-2 "
                  onClick={validateClicked}
                >
                  <p className="text-sm text-inherit">Re-Validate</p>
                </button>
                <button
                  type="button"
                  data-test="re-upload"
                  className=" flex mr-4
                                  2xl:mr-8

                                     bg-sunrise  hover:bg-white
                                    hover:text-sunrise
                                    hover:!outline-2
                                    hover:!outline 
                                    hover:outline-sunrise
                                    active:bg-orange-800  text-white border  cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105 duration-200   h-8 rounded-md justify-start items-center duration-500 p-2 "
                  onClick={() => {
                    setFilesSelecting(true);
                    inputRef.current.click();
                    setTimeout(() => setFilesSelecting(false), 2000);
                  }}
                >
                  <p className="text-sm">Re-Upload</p>
                  {filesSelecting && <Spinner className="small-spinner" loading={filesSelecting} />}
                </button>

                <button
                  type="button"
                  data-test="download-file"
                  className=" flex 2xl:mr-8 
                                     bg-sunrise  hover:bg-white
                                    hover:text-sunrise
                                    hover:!outline-2
                                    hover:!outline 
                                    hover:outline-sunrise
                                    active:bg-orange-800  text-white border  cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105 duration-200   h-8 rounded-md justify-start items-center duration-500 p-2 "
                  onClick={downloadClicked}
                >
                  <p className="text-sm">Download File</p>
                </button>
              </div>

              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                  Last Validation Date
                </p>
                <div className="flex items-center">
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.validationDateString}
                  </p>
                  <div className={`flex ${fileDetails.fileTheme}`}>
                    {fileDetails.validationDayComponent()}
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Validation By</p>
                <p className="text-dark-night text-sm font-normal leading-normal">
                  {capitalize(fileDetails.validatedBy)}
                </p>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                  Validation Status
                </p>
                <div className="flex items-center">
                  {fileDetails.valid ? (
                    <>
                      <p
                        className="text-dark-night text-sm font-normal leading-normal"
                        data-test="edd-valid"
                      >
                        Valid
                      </p>
                      <i className="ml-1 fa fa-check-circle-o !text-green-500 !text-[24px] opacity-90" />
                    </>
                  ) : (
                    <>
                      <p
                        className="text-dark-night text-sm font-normal leading-normal"
                        data-test="edd-invalid"
                      >
                        Invalid
                      </p>
                      <i className="ml-1 fa fa-times-circle-o !text-red-500 !text-[24px] opacity-90" />
                    </>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Rows Failed</p>
                <p className="text-dark-night text-sm font-normal leading-normal">
                  {fileDetails.errorCount}
                </p>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 col-span-1 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Error Count</p>
                <p className="text-dark-night text-sm font-normal leading-normal">
                  {fileDetails.errorCount}
                </p>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-2 pl-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Row Count</p>
                <p className="text-dark-night text-sm font-normal leading-normal">
                  {fileDetails.noOfRows}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full  mt-4 shadow-2xl z-40 shadow-[20px_20px_60px_#bebebe_-10px_-20px_60px_#ffffff] shadow-[#bebebe] ">
          <div className="w-full h-full  bg-white/30 backdrop-blur-[24px] outline-solid outline-white  ">
            <div className="p-4 grid grid-cols-3">
              <div className="col-span-1 flex mb-2">
                <p className="font-bold text-dark-night">Date Details</p>
              </div>

              <div className="col-span-2 flex items-space-around mb-2">
                <button
                  type="button"
                  className=" flex mr-4
                                  2xl:mr-8 border   bg-green-600 
                                active:bg-green-800 
                                hover:!outline 
                                hover:!outline-2
                                text-white
                                hover:text-green-500
                                hover:bg-white
                                hover:outline-green-400 
                                duration-200
                                cursor-pointer text-white font-semibold hover:scale-x-105 hover:scale-y-105   hover:bg-slate-50 h-8 rounded-md justify-start items-center  p-2 "
                  onClick={scheduleClicked}
                >
                  <p className="text-sm text-inherit">Schedule Import</p>
                </button>

                <button
                  type="button"
                  className=" flex mr-4
                                  2xl:mr-8 bg-red-500
                            active:bg-red-800 
                                hover:!outline 
                                hover:!outline-2
                                text-white
                                hover:text-red-500
                                hover:bg-white
                            hover:outline-red-400  text-white
                                cursor-pointer font-semibold hover:scale-x-105 hover:scale-y-105   
                                h-8 rounded-md justify-start items-center duration-200 p-2 "
                  onClick={() => {
                    handleScheduleCanceled();
                  }}
                >
                  <p className="text-sm text-inherit">Cancel Schedule</p>
                </button>

                {fileDetails.fileType !== 'tag' && (
                  <button
                    type="button"
                    className="flex border bg-green-600 
                                active:bg-green-800 
                                hover:!outline 
                                hover:!outline-2
                                text-white
                                hover:text-green-500
                                hover:bg-white
                                hover:outline-green-400 
                                duration-200
                                cursor-pointer text-white font-semibold hover:scale-x-105 hover:scale-y-105   hover:bg-slate-50 h-8 rounded-md justify-start items-center  p-2"
                    onClick={scheduleDeployClicked}
                    disabled={fileDetails.fileType === 'tag'}
                  >
                    <p className="text-sm text-inherit">Schedule Deploy</p>
                  </button>
                )}
              </div>

              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Uploaded Date</p>
                <div className="flex items-center">
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.uploadedDateString}
                  </p>
                  <div className={`flex ${fileDetails.fileTheme}`}>
                    {fileDetails.uploadedDayComponent()}
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                  Last Validation Date
                </p>
                <div className="flex items-center">
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.validationDateString}
                  </p>
                  <div className={`flex ${fileDetails.fileTheme}`}>
                    {fileDetails.validationDayComponent()}
                  </div>
                </div>
              </div>
              <div
                className={`flex ${fileDetails.fileTheme} flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-2`}
              >
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Imported Date</p>
                <div className="flex items-center">
                  {fileDetails.importedDateString === 'incoming' ? (
                    <p className="text-dark-night text-sm font-normal leading-normal">
                      not yet imported
                    </p>
                  ) : (
                    <>
                      <p className="text-dark-night text-sm font-normal leading-normal">
                        {fileDetails.importedDateString}
                      </p>
                      <div className={`flex ${fileDetails.fileTheme}`}>
                        {fileDetails.importDayComponent()}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-4 pr-2 col-span-1">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                  Scheduled Import Date
                </p>
                <div className={`${fileDetails.fileTheme} flex items-center`}>
                  {fileDetails.scheduledImportDateString === 'incoming' ? (
                    <p className="text-dark-night text-sm font-normal leading-normal">
                      {' '}
                      {fileDetails.importStatus === 'imported'
                        ? 'imported without schedule'
                        : 'Date Not Set'}
                    </p>
                  ) : (
                    <>
                      {' '}
                      <p className="text-dark-night text-sm font-normal leading-normal">
                        {fileDetails.scheduledImportDateString}
                      </p>
                      <div className={`flex ${fileDetails.fileTheme}`}>
                        {fileDetails.scheduledImportDayComponent()}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-4 col-span-1 pr-2">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                  Scheduled Import Time
                </p>
                <div className="flex items-center">
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.importStatus === 'imported' &&
                    fileDetails.scheduledImportReadableTime === 'incoming'
                      ? 'imported without schedules'
                      : fileDetails.scheduledImportReadableTime}
                  </p>
                  {fileDetails.scheduledImportDateTimeComponent()}
                </div>
              </div>
              <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-4 pr-2 col-span-1 pr-[50%]">
                <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Import Time</p>
                <div className="flex items-center">
                  <p className="text-dark-night text-sm font-normal leading-normal">
                    {fileDetails.importReadableTime}
                  </p>
                  {fileDetails.importDateTimeComponent()}
                </div>
              </div>
              {fileDetails.fileType !== 'tag' && (
                <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] py-4 pr-2 col-span-1">
                  <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                    Scheduled Deployment Date
                  </p>
                  <div className={`${fileDetails.fileTheme} flex items-center`}>
                    {fileDetails.scheduledDeploymentDateString === 'incoming' ? (
                      <p className="text-dark-night text-sm font-normal leading-normal">
                        {' '}
                        {fileDetails.deployStatus === 'Successfully Deployed'
                          ? 'Deployed without schedule'
                          : 'Date Not Set'}
                      </p>
                    ) : (
                      <>
                        {' '}
                        <p className="text-dark-night text-sm font-normal leading-normal">
                          {fileDetails.scheduledDeploymentDateString}
                        </p>
                        <div className={`flex ${fileDetails.fileTheme}`}>
                          {fileDetails.scheduledDeploymentDayComponent()}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              {fileDetails.fileType !== 'tag' && (
                <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-4 col-span-1 pr-2">
                  <p className="text-[#6B6B6B] text-sm font-normal leading-normal">
                    Scheduled Deploy Time
                  </p>
                  <div className="flex items-center">
                    <p className="text-dark-night text-sm font-normal leading-normal">
                      {fileDetails.deployStatus === 'Successfully Deployed' &&
                      fileDetails.scheduledDeploymentReadableTime === 'incoming'
                        ? 'deployed without schedules'
                        : fileDetails.scheduledDeploymentReadableTime}
                    </p>
                    {fileDetails.scheduledDeploymentDateTimeComponent()}
                  </div>
                </div>
              )}

              {fileDetails.fileType !== 'tag' && (
                <div className="flex flex-col gap-1 border-t border-solid border-t-[#DEDEDE] pt-4 pr-2 col-span-1 pr-[50%]">
                  <p className="text-[#6B6B6B] text-sm font-normal leading-normal">Deploy Time</p>
                  <div className="flex items-center">
                    <p className="text-dark-night text-sm font-normal leading-normal">
                      {fileDetails.deployReadableTime}
                    </p>
                    {fileDetails.deployTimeComponent()}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

EddFileInfo.propTypes = {
  fileDetails: PropTypes.object,
  scheduleClicked: PropTypes.func,
  importClicked: PropTypes.func,
  deployClicked: PropTypes.func,
  validateClicked: PropTypes.func,
  deleteClicked: PropTypes.func,
  filesSelecting: PropTypes.bool,
  setFilesSelecting: PropTypes.func,
  handleScheduleCanceled: PropTypes.func,
  handleInputChange: PropTypes.func,
  scheduleDeployClicked: PropTypes.func,
  downloadClicked: PropTypes.func,
};
